'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { logger } from '@/lib/telemetry/logger';
async function loadLandingStyles(): Promise<void> {
  await import('@/app/deferred-landing-styles-entry');
}
export function DeferredLandingStyles() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
}
function _temp2() {
  loadLandingStyles().catch(_temp);
}
function _temp(error) {
  logger.warn("landing_styles.load_failed", {
    error: error instanceof Error ? error.message.slice(0, 200) : String(error)
  });
}